import { createContext, useContext } from 'react'

interface LayoutContextValue {
  onMenuToggle: () => void
}

export const LayoutContext = createContext<LayoutContextValue>({ onMenuToggle: () => {} })

export const useLayout = () => useContext(LayoutContext)
